import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { TestStatusDto } from '../../2_domain/test/test';

const useDashboardController = (
  statusDone: TestStatusDto,
  statusOthers: TestStatusDto[]
) => {
  const theme = useTheme();
  const [fromDate, setFromDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const applyDateRange = (fromDate: Date, endDate: Date) => {
    return async () => {
      setFromDate(fromDate);
      setEndDate(endDate);
    };
  };

  const [showRange, setShowRange] = useState(false);
  const [rangeValue, setRangeValue] = useState(theme.texts.today);
  const [rangeOptions, setRangeOptions] = useState([
    theme.texts.today,
    theme.texts.dateRange,
  ]);

  useEffect(() => {
    // setRangeValue(theme.texts.today);
    setRangeOptions([theme.texts.today, theme.texts.dateRange]);
    // setShowRange(rangeValue === theme.texts.dateRange);
    // setFromDate(undefined);
    // setEndDate(undefined);
  }, [rangeValue, theme]);

  const changeRangeOption = (option: string) => {
    setShowRange(option === theme.texts.dateRange);
    setRangeValue(option);
    if (option === theme.texts.today) {
      setFromDate(undefined);
      setEndDate(undefined);
    }
  };

  return {
    applyDateRange,
    showRange,
    rangeOptions,
    rangeValue,
    changeRangeOption,
    fromDate,
    endDate,
    statusDone,
    statusOthers,
  };
};

export default useDashboardController;
